export { Separator } from './separator.style';
